import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { TextButtonType, TextButton } from 'view/components/buttons'
import { canManageHolidaysSelector } from 'selectors/permissionSelectors'
import { Locale, Translation } from 'locale'
import { HolidayDialog } from './HolidayDialog'

interface HolidayToolbarProps extends ModalConsumerProps {
  canManageHolidays: boolean
}

const mapStateToProps = createStructuredSelector({
  canManageHolidays: canManageHolidaysSelector
})

const mapDispatchToProps = {}

class HolidayToolbarComponent extends React.Component<HolidayToolbarProps> {
  render() {
    const { canManageHolidays } = this.props

    if (!canManageHolidays) {
      return null
    }

    return (
      <TextButton dataTestId={'HolidayToolbar-TextButton-ButtonNewHoliday'} type={TextButtonType.Primary} onClick={this.onClick}>
        {Locale.translate(Translation.TC_BUTTON_NEW_HOLIDAY)}
      </TextButton>
    )
  }

  private onClick = () => {
    this.props.showModal(<HolidayDialog />)
  }
}

export const HolidayToolbar = withModal(connect(mapStateToProps, mapDispatchToProps)(HolidayToolbarComponent))
